/**
 * 活动商品可能复用普通商品的 product_id；选中态必须使用独立 key，
 * 避免活动卡被选中时，下方同 product_id 的普通商品也显示选中态。
 */
export function getActivityOfferSelectionId(productId: string): string {
    return `activity-offer:${productId}`;
}
